module.exports = __webpack_public_path__ + "static/media/7.967b8ffa.png";